const initialize = () => document.querySelectorAll('[data-ph]').forEach(root => {
  if (root.dataset.nnEnhanced) return;
  root.dataset.nnEnhanced = 'true';
  const inputs = [...root.querySelectorAll('[data-pack-input]')];
  const main = root.querySelector('input[name="quantity"]');
  if (!main) return;
  const money = cents => new Intl.NumberFormat(root.dataset.locale || 'en', { style: 'currency', currency: root.dataset.currency || 'USD', minimumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
  function sync(value = main.value) {
    const quantity = Math.min(99, Math.max(1, Math.floor(Number(value) || 1)));
    inputs.forEach(input => { input.value = String(quantity); });
    root.querySelector('product-form-component').dataset.quantityDefault = String(quantity);
    root.querySelectorAll('[data-pack-step]').forEach(button => { button.disabled = Number(button.dataset.packStep) < 0 ? quantity <= 1 : quantity >= 99; });
    const pack = root.querySelector('[data-ph-pack][aria-checked="true"]');
    if (!pack) return;
    const price = Number(pack.dataset.priceCents) * quantity;
    const comparison = Number(pack.dataset.compareCents) * quantity;
    const saving = Math.max(0, comparison - price);
    ['[data-ph-now]', '[data-ph-sticky-price]'].forEach(selector => { const el = root.querySelector(selector); if (el) el.textContent = money(price); });
    ['[data-ph-was]', '[data-ph-sticky-was]'].forEach(selector => { const el = root.querySelector(selector); if (el) { el.textContent = money(comparison); el.hidden = !saving; } });
    ['[data-ph-save]', '[data-ph-sticky-save]', '[data-ph-flag-text]'].forEach(selector => { const el = root.querySelector(selector); if (el) { el.textContent = `${root.dataset.saveLabel} ${money(saving)}`; el.hidden = !saving; } });
    const devices = quantity * Number(pack.dataset.packSize);
    root.querySelector('[data-pack-summary-output]').textContent = root.dataset.packSummary.replace('{packs}', quantity).replace('{devices}', devices).replace('{total}', money(price));
  }
  root.addEventListener('click', event => {
    const button = event.target.closest('[data-pack-step]');
    if (!button) return;
    event.preventDefault();
    sync(Number(main.value) + Number(button.dataset.packStep));
  });
  inputs.forEach(input => input.addEventListener('change', () => sync(input.value)));
  root.addEventListener('nailnova:pack-change', () => {
    sync();
    const selected = root.querySelector('[data-ph-variant-input]');
    const termsVariant = root.querySelector('[data-ph-terms-variant]');
    if (selected && termsVariant && termsVariant.value !== selected.value) {
      termsVariant.value = selected.value;
      termsVariant.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  root.querySelector('.b-ph__form form').addEventListener('submit', () => sync(), true);
  sync();

  const dialog = root.querySelector('[data-product-gallery]');
  const photographs = [...root.querySelectorAll('[data-gallery-open]')];
  if (!dialog || !photographs.length) return;
  let current = 0;
  let trigger;
  const image = dialog.querySelector('[data-gallery-image]');
  const thumbs = [...dialog.querySelectorAll('[data-gallery-thumb]')];
  function display(index) {
    current = (index + photographs.length) % photographs.length;
    const photo = photographs[current];
    image.src = photo.href;
    image.alt = photo.dataset.galleryAlt;
    dialog.querySelector('[data-gallery-count]').textContent = `${current + 1} / ${photographs.length}`;
    thumbs.forEach(thumb => { thumb.setAttribute('aria-pressed', String(thumb.dataset.galleryThumb === photo.dataset.galleryOpen)); });
  }
  photographs.forEach((photo, index) => photo.addEventListener('click', event => {
    if (event.metaKey || event.ctrlKey || event.shiftKey) return;
    event.preventDefault();
    trigger = photo;
    display(index);
    root.querySelectorAll('video').forEach(video => video.pause());
    dialog.showModal();
    document.documentElement.classList.add('nn-gallery-open');
    dialog.querySelector('[data-gallery-close]').focus();
  }));
  dialog.addEventListener('click', event => {
    if (event.target === dialog || event.target.closest('[data-gallery-close]')) dialog.close();
    const step = event.target.closest('[data-gallery-step]');
    if (step) display(current + Number(step.dataset.galleryStep));
    const thumb = event.target.closest('[data-gallery-thumb]');
    if (thumb) display(photographs.findIndex(photo => photo.dataset.galleryOpen === thumb.dataset.galleryThumb));
  });
  dialog.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); display(current + (event.key === 'ArrowRight' ? 1 : -1)); }
  });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('nn-gallery-open');
    trigger?.focus({ preventScroll: true });
  });
});
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
else initialize();
document.addEventListener('shopify:section:load', initialize);
document.addEventListener('click', event => {
  const link = event.target.closest('[data-nn-scroll-target]');
  if (!link) return;
  const target = document.querySelector(link.dataset.nnScrollTarget);
  if (!target || !window.Brand?.scrollToEl) return;
  event.preventDefault();
  window.Brand.scrollToEl(target, 110, !window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  target.setAttribute('tabindex', '-1');
  target.focus({ preventScroll: true });
});
